export type YearlyRates = { percentChange: number; rates: { rate: number; year: number }[] };

// Data from the "Residential December 20XX YTD" column
// in Table 5.6.B of the EIA Electric Power Monthly report.
//
// Replace "20XX" with the actual year in the following URL:
// https://www.eia.gov/electricity/monthly/archive/february20XX.pdf#page=138
export const ratesByState: Record<string, YearlyRates> = {
  AK: {
    percentChange: 15.7,
    rates: [
      {
        rate: 22.55,
        year: 2021,
      },
      {
        rate: 23.02,
        year: 2022,
      },
      {
        rate: 23.9,
        year: 2023,
      },
      {
        rate: 24.82,
        year: 2024,
      },
      {
        rate: 26.09,
        year: 2025,
      },
    ],
  },
  AL: {
    percentChange: 24.2,
    rates: [
      {
        rate: 12.96,
        year: 2021,
      },
      {
        rate: 14.39,
        year: 2022,
      },
      {
        rate: 14.63,
        year: 2023,
      },
      {
        rate: 15.18,
        year: 2024,
      },
      {
        rate: 16.1,
        year: 2025,
      },
    ],
  },
  AR: {
    percentChange: 13.9,
    rates: [
      {
        rate: 11.27,
        year: 2021,
      },
      {
        rate: 11.86,
        year: 2022,
      },
      {
        rate: 12.25,
        year: 2023,
      },
      {
        rate: 12.32,
        year: 2024,
      },
      {
        rate: 12.84,
        year: 2025,
      },
    ],
  },
  AZ: {
    percentChange: 22.2,
    rates: [
      {
        rate: 12.54,
        year: 2021,
      },
      {
        rate: 13.02,
        year: 2022,
      },
      {
        rate: 14.02,
        year: 2023,
      },
      {
        rate: 14.91,
        year: 2024,
      },
      {
        rate: 15.32,
        year: 2025,
      },
    ],
  },
  CA: {
    percentChange: 42.6,
    rates: [
      {
        rate: 22.82,
        year: 2021,
      },
      {
        rate: 26.17,
        year: 2022,
      },
      {
        rate: 29.51,
        year: 2023,
      },
      {
        rate: 31.97,
        year: 2024,
      },
      {
        rate: 32.54,
        year: 2025,
      },
    ],
  },
  CO: {
    percentChange: 21.3,
    rates: [
      {
        rate: 13.07,
        year: 2021,
      },
      {
        rate: 14.29,
        year: 2022,
      },
      {
        rate: 14.3,
        year: 2023,
      },
      {
        rate: 14.92,
        year: 2024,
      },
      {
        rate: 15.85,
        year: 2025,
      },
    ],
  },
  CT: {
    percentChange: 34.1,
    rates: [
      {
        rate: 21.91,
        year: 2021,
      },
      {
        rate: 24.65,
        year: 2022,
      },
      {
        rate: 29.88,
        year: 2023,
      },
      {
        rate: 28.75,
        year: 2024,
      },
      {
        rate: 29.38,
        year: 2025,
      },
    ],
  },
  DC: {
    percentChange: 67.6,
    rates: [
      {
        rate: 13.09,
        year: 2021,
      },
      {
        rate: 14.2,
        year: 2022,
      },
      {
        rate: 16.45,
        year: 2023,
      },
      {
        rate: 17.71,
        year: 2024,
      },
      {
        rate: 21.94,
        year: 2025,
      },
    ],
  },
  DE: {
    percentChange: 36.8,
    rates: [
      {
        rate: 12.52,
        year: 2021,
      },
      {
        rate: 13.73,
        year: 2022,
      },
      {
        rate: 15.73,
        year: 2023,
      },
      {
        rate: 16.57,
        year: 2024,
      },
      {
        rate: 17.13,
        year: 2025,
      },
    ],
  },
  FL: {
    percentChange: 28.1,
    rates: [
      {
        rate: 11.9,
        year: 2021,
      },
      {
        rate: 13.92,
        year: 2022,
      },
      {
        rate: 15.21,
        year: 2023,
      },
      {
        rate: 14.14,
        year: 2024,
      },
      {
        rate: 15.24,
        year: 2025,
      },
    ],
  },
  GA: {
    percentChange: 17.7,
    rates: [
      {
        rate: 12.51,
        year: 2021,
      },
      {
        rate: 14.02,
        year: 2022,
      },
      {
        rate: 13.69,
        year: 2023,
      },
      {
        rate: 14.08,
        year: 2024,
      },
      {
        rate: 14.73,
        year: 2025,
      },
    ],
  },
  HI: {
    percentChange: 21.2,
    rates: [
      {
        rate: 33.49,
        year: 2021,
      },
      {
        rate: 43.02,
        year: 2022,
      },
      {
        rate: 42.39,
        year: 2023,
      },
      {
        rate: 42.86,
        year: 2024,
      },
      {
        rate: 40.59,
        year: 2025,
      },
    ],
  },
  IA: {
    percentChange: 7.8,
    rates: [
      {
        rate: 12.73,
        year: 2021,
      },
      {
        rate: 13.07,
        year: 2022,
      },
      {
        rate: 13.31,
        year: 2023,
      },
      {
        rate: 13.4,
        year: 2024,
      },
      {
        rate: 13.72,
        year: 2025,
      },
    ],
  },
  ID: {
    percentChange: 16.3,
    rates: [
      {
        rate: 10.16,
        year: 2021,
      },
      {
        rate: 10.42,
        year: 2022,
      },
      {
        rate: 11.05,
        year: 2023,
      },
      {
        rate: 11.52,
        year: 2024,
      },
      {
        rate: 11.82,
        year: 2025,
      },
    ],
  },
  IL: {
    percentChange: 34.2,
    rates: [
      {
        rate: 13.18,
        year: 2021,
      },
      {
        rate: 15.87,
        year: 2022,
      },
      {
        rate: 15.71,
        year: 2023,
      },
      {
        rate: 15.87,
        year: 2024,
      },
      {
        rate: 17.69,
        year: 2025,
      },
    ],
  },
  IN: {
    percentChange: 21.4,
    rates: [
      {
        rate: 13.37,
        year: 2021,
      },
      {
        rate: 14.98,
        year: 2022,
      },
      {
        rate: 14.94,
        year: 2023,
      },
      {
        rate: 14.77,
        year: 2024,
      },
      {
        rate: 16.23,
        year: 2025,
      },
    ],
  },
  KS: {
    percentChange: 12.2,
    rates: [
      {
        rate: 12.98,
        year: 2021,
      },
      {
        rate: 14.13,
        year: 2022,
      },
      {
        rate: 13.38,
        year: 2023,
      },
      {
        rate: 14.15,
        year: 2024,
      },
      {
        rate: 14.56,
        year: 2025,
      },
    ],
  },
  KY: {
    percentChange: 15.1,
    rates: [
      {
        rate: 11.5,
        year: 2021,
      },
      {
        rate: 12.85,
        year: 2022,
      },
      {
        rate: 12.65,
        year: 2023,
      },
      {
        rate: 12.79,
        year: 2024,
      },
      {
        rate: 13.24,
        year: 2025,
      },
    ],
  },
  LA: {
    percentChange: 14.1,
    rates: [
      {
        rate: 11.02,
        year: 2021,
      },
      {
        rate: 12.69,
        year: 2022,
      },
      {
        rate: 11.55,
        year: 2023,
      },
      {
        rate: 11.73,
        year: 2024,
      },
      {
        rate: 12.57,
        year: 2025,
      },
    ],
  },
  MA: {
    percentChange: 33.2,
    rates: [
      {
        rate: 22.89,
        year: 2021,
      },
      {
        rate: 26.1,
        year: 2022,
      },
      {
        rate: 29.61,
        year: 2023,
      },
      {
        rate: 29.35,
        year: 2024,
      },
      {
        rate: 30.48,
        year: 2025,
      },
    ],
  },
  MD: {
    percentChange: 48.5,
    rates: [
      {
        rate: 13.12,
        year: 2021,
      },
      {
        rate: 14.51,
        year: 2022,
      },
      {
        rate: 16.6,
        year: 2023,
      },
      {
        rate: 17.86,
        year: 2024,
      },
      {
        rate: 19.48,
        year: 2025,
      },
    ],
  },
  ME: {
    percentChange: 63.2,
    rates: [
      {
        rate: 17.02,
        year: 2021,
      },
      {
        rate: 22.52,
        year: 2022,
      },
      {
        rate: 27.42,
        year: 2023,
      },
      {
        rate: 24.29,
        year: 2024,
      },
      {
        rate: 27.78,
        year: 2025,
      },
    ],
  },
  MI: {
    percentChange: 14.1,
    rates: [
      {
        rate: 17.54,
        year: 2021,
      },
      {
        rate: 17.75,
        year: 2022,
      },
      {
        rate: 18.84,
        year: 2023,
      },
      {
        rate: 19.3,
        year: 2024,
      },
      {
        rate: 20.01,
        year: 2025,
      },
    ],
  },
  MN: {
    percentChange: 17.2,
    rates: [
      {
        rate: 13.5,
        year: 2021,
      },
      {
        rate: 14.16,
        year: 2022,
      },
      {
        rate: 14.73,
        year: 2023,
      },
      {
        rate: 15.45,
        year: 2024,
      },
      {
        rate: 15.82,
        year: 2025,
      },
    ],
  },
  MO: {
    percentChange: 18.2,
    rates: [
      {
        rate: 11.41,
        year: 2021,
      },
      {
        rate: 12.29,
        year: 2022,
      },
      {
        rate: 12.58,
        year: 2023,
      },
      {
        rate: 12.91,
        year: 2024,
      },
      {
        rate: 13.49,
        year: 2025,
      },
    ],
  },
  MS: {
    percentChange: 21.4,
    rates: [
      {
        rate: 11.56,
        year: 2021,
      },
      {
        rate: 12.65,
        year: 2022,
      },
      {
        rate: 13.23,
        year: 2023,
      },
      {
        rate: 13.39,
        year: 2024,
      },
      {
        rate: 14.03,
        year: 2025,
      },
    ],
  },
  MT: {
    percentChange: 15.7,
    rates: [
      {
        rate: 11.22,
        year: 2021,
      },
      {
        rate: 11.37,
        year: 2022,
      },
      {
        rate: 12.54,
        year: 2023,
      },
      {
        rate: 12.66,
        year: 2024,
      },
      {
        rate: 12.98,
        year: 2025,
      },
    ],
  },
  NC: {
    percentChange: 23.9,
    rates: [
      {
        rate: 11.32,
        year: 2021,
      },
      {
        rate: 12.08,
        year: 2022,
      },
      {
        rate: 12.93,
        year: 2023,
      },
      {
        rate: 14.13,
        year: 2024,
      },
      {
        rate: 14.02,
        year: 2025,
      },
    ],
  },
  ND: {
    percentChange: 8.8,
    rates: [
      {
        rate: 10.85,
        year: 2021,
      },
      {
        rate: 10.9,
        year: 2022,
      },
      {
        rate: 11.01,
        year: 2023,
      },
      {
        rate: 11.51,
        year: 2024,
      },
      {
        rate: 11.81,
        year: 2025,
      },
    ],
  },
  NE: {
    percentChange: 14.8,
    rates: [
      {
        rate: 10.75,
        year: 2021,
      },
      {
        rate: 10.93,
        year: 2022,
      },
      {
        rate: 11.2,
        year: 2023,
      },
      {
        rate: 11.53,
        year: 2024,
      },
      {
        rate: 12.34,
        year: 2025,
      },
    ],
  },
  NH: {
    percentChange: 23.7,
    rates: [
      {
        rate: 19.85,
        year: 2021,
      },
      {
        rate: 25.5,
        year: 2022,
      },
      {
        rate: 28.15,
        year: 2023,
      },
      {
        rate: 23.4,
        year: 2024,
      },
      {
        rate: 24.56,
        year: 2025,
      },
    ],
  },
  NJ: {
    percentChange: 38.4,
    rates: [
      {
        rate: 16.35,
        year: 2021,
      },
      {
        rate: 16.79,
        year: 2022,
      },
      {
        rate: 17.7,
        year: 2023,
      },
      {
        rate: 19.34,
        year: 2024,
      },
      {
        rate: 22.63,
        year: 2025,
      },
    ],
  },
  NM: {
    percentChange: 11.5,
    rates: [
      {
        rate: 13.52,
        year: 2021,
      },
      {
        rate: 14.11,
        year: 2022,
      },
      {
        rate: 13.85,
        year: 2023,
      },
      {
        rate: 14.2,
        year: 2024,
      },
      {
        rate: 15.08,
        year: 2025,
      },
    ],
  },
  NV: {
    percentChange: 14.4,
    rates: [
      {
        rate: 11.49,
        year: 2021,
      },
      {
        rate: 13.79,
        year: 2022,
      },
      {
        rate: 16.67,
        year: 2023,
      },
      {
        rate: 15,
        year: 2024,
      },
      {
        rate: 13.15,
        year: 2025,
      },
    ],
  },
  NY: {
    percentChange: 35.5,
    rates: [
      {
        rate: 19.48,
        year: 2021,
      },
      {
        rate: 22.04,
        year: 2022,
      },
      {
        rate: 22.24,
        year: 2023,
      },
      {
        rate: 24.43,
        year: 2024,
      },
      {
        rate: 26.39,
        year: 2025,
      },
    ],
  },
  OH: {
    percentChange: 32.8,
    rates: [
      {
        rate: 12.77,
        year: 2021,
      },
      {
        rate: 14.01,
        year: 2022,
      },
      {
        rate: 15.38,
        year: 2023,
      },
      {
        rate: 15.99,
        year: 2024,
      },
      {
        rate: 16.96,
        year: 2025,
      },
    ],
  },
  OK: {
    percentChange: 19.3,
    rates: [
      {
        rate: 11,
        year: 2021,
      },
      {
        rate: 12.57,
        year: 2022,
      },
      {
        rate: 12.08,
        year: 2023,
      },
      {
        rate: 12.24,
        year: 2024,
      },
      {
        rate: 13.12,
        year: 2025,
      },
    ],
  },
  OR: {
    percentChange: 35.2,
    rates: [
      {
        rate: 11.37,
        year: 2021,
      },
      {
        rate: 11.35,
        year: 2022,
      },
      {
        rate: 12.73,
        year: 2023,
      },
      {
        rate: 14.7,
        year: 2024,
      },
      {
        rate: 15.37,
        year: 2025,
      },
    ],
  },
  PA: {
    percentChange: 40.3,
    rates: [
      {
        rate: 13.76,
        year: 2021,
      },
      {
        rate: 16.06,
        year: 2022,
      },
      {
        rate: 18.1,
        year: 2023,
      },
      {
        rate: 17.77,
        year: 2024,
      },
      {
        rate: 19.3,
        year: 2025,
      },
    ],
  },
  RI: {
    percentChange: 32.1,
    rates: [
      {
        rate: 22.3,
        year: 2021,
      },
      {
        rate: 23.2,
        year: 2022,
      },
      {
        rate: 27.02,
        year: 2023,
      },
      {
        rate: 28.65,
        year: 2024,
      },
      {
        rate: 29.46,
        year: 2025,
      },
    ],
  },
  SC: {
    percentChange: 16.3,
    rates: [
      {
        rate: 12.86,
        year: 2021,
      },
      {
        rate: 14.11,
        year: 2022,
      },
      {
        rate: 13.68,
        year: 2023,
      },
      {
        rate: 14.23,
        year: 2024,
      },
      {
        rate: 14.96,
        year: 2025,
      },
    ],
  },
  SD: {
    percentChange: 9.5,
    rates: [
      {
        rate: 12.22,
        year: 2021,
      },
      {
        rate: 12.17,
        year: 2022,
      },
      {
        rate: 12.32,
        year: 2023,
      },
      {
        rate: 12.86,
        year: 2024,
      },
      {
        rate: 13.38,
        year: 2025,
      },
    ],
  },
  TN: {
    percentChange: 19.1,
    rates: [
      {
        rate: 11.07,
        year: 2021,
      },
      {
        rate: 12.37,
        year: 2022,
      },
      {
        rate: 12.19,
        year: 2023,
      },
      {
        rate: 12.42,
        year: 2024,
      },
      {
        rate: 13.18,
        year: 2025,
      },
    ],
  },
  TX: {
    percentChange: 27.7,
    rates: [
      {
        rate: 12.11,
        year: 2021,
      },
      {
        rate: 13.55,
        year: 2022,
      },
      {
        rate: 14.46,
        year: 2023,
      },
      {
        rate: 14.94,
        year: 2024,
      },
      {
        rate: 15.47,
        year: 2025,
      },
    ],
  },
  USA: {
    percentChange: 26.6,
    rates: [
      {
        rate: 13.66,
        year: 2021,
      },
      {
        rate: 15.12,
        year: 2022,
      },
      {
        rate: 16,
        year: 2023,
      },
      {
        rate: 16.48,
        year: 2024,
      },
      {
        rate: 17.3,
        year: 2025,
      },
    ],
  },
  UT: {
    percentChange: 25.3,
    rates: [
      {
        rate: 10.43,
        year: 2021,
      },
      {
        rate: 10.94,
        year: 2022,
      },
      {
        rate: 11.2,
        year: 2023,
      },
      {
        rate: 12.22,
        year: 2024,
      },
      {
        rate: 13.07,
        year: 2025,
      },
    ],
  },
  VA: {
    percentChange: 27.8,
    rates: [
      {
        rate: 11.96,
        year: 2021,
      },
      {
        rate: 13.52,
        year: 2022,
      },
      {
        rate: 14.26,
        year: 2023,
      },
      {
        rate: 14.41,
        year: 2024,
      },
      {
        rate: 15.28,
        year: 2025,
      },
    ],
  },
  VT: {
    percentChange: 19,
    rates: [
      {
        rate: 19.26,
        year: 2021,
      },
      {
        rate: 20.18,
        year: 2022,
      },
      {
        rate: 20.82,
        year: 2023,
      },
      {
        rate: 21.9,
        year: 2024,
      },
      {
        rate: 22.92,
        year: 2025,
      },
    ],
  },
  WA: {
    percentChange: 29.7,
    rates: [
      {
        rate: 10.11,
        year: 2021,
      },
      {
        rate: 10.23,
        year: 2022,
      },
      {
        rate: 10.98,
        year: 2023,
      },
      {
        rate: 11.9,
        year: 2024,
      },
      {
        rate: 13.11,
        year: 2025,
      },
    ],
  },
  WI: {
    percentChange: 25.1,
    rates: [
      {
        rate: 14.52,
        year: 2021,
      },
      {
        rate: 15.5,
        year: 2022,
      },
      {
        rate: 16.88,
        year: 2023,
      },
      {
        rate: 17.18,
        year: 2024,
      },
      {
        rate: 18.16,
        year: 2025,
      },
    ],
  },
  WV: {
    percentChange: 26.8,
    rates: [
      {
        rate: 12.15,
        year: 2021,
      },
      {
        rate: 13.25,
        year: 2022,
      },
      {
        rate: 14.05,
        year: 2023,
      },
      {
        rate: 15.07,
        year: 2024,
      },
      {
        rate: 15.41,
        year: 2025,
      },
    ],
  },
  WY: {
    percentChange: 19.8,
    rates: [
      {
        rate: 11.17,
        year: 2021,
      },
      {
        rate: 11.1,
        year: 2022,
      },
      {
        rate: 11.46,
        year: 2023,
      },
      {
        rate: 12.47,
        year: 2024,
      },
      {
        rate: 13.38,
        year: 2025,
      },
    ],
  },
};
